import { API } from "@/lib/api";

const VKEY = "dd_visitor_id";
const SKEY = "dd_session_id";

const rid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : String(Math.random()).slice(2) + Date.now());

export function getVisitorId() {
  let v = localStorage.getItem(VKEY);
  if (!v) { v = rid(); localStorage.setItem(VKEY, v); }
  return v;
}
export function getSessionId() {
  let v = sessionStorage.getItem(SKEY);
  if (!v) { v = rid(); sessionStorage.setItem(SKEY, v); }
  return v;
}

export function isTracked(path) {
  return !(path.startsWith("/admin") || path === "/login" || path.startsWith("/preview"));
}

export function sendView(path) {
  const body = JSON.stringify({
    type: "view", path, slug: path.replace(/^\//, "") || null,
    referrer: document.referrer || "", visitor_id: getVisitorId(), session_id: getSessionId(),
  });
  try {
    fetch(`${API}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch (e) { /* ignore */ }
}

export function sendDuration(path, ms) {
  if (!ms || ms < 500) return;
  const body = JSON.stringify({
    type: "duration", path, duration_ms: Math.round(ms),
    referrer: "", visitor_id: getVisitorId(), session_id: getSessionId(),
  });
  try {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon) navigator.sendBeacon(`${API}/track`, blob);
    else fetch(`${API}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch (e) { /* ignore */ }
}

// Custom interaction events (e.g. Help bubble opens). Fire-and-forget.
export function sendEvent(name) {
  const body = JSON.stringify({
    type: "event", event: name, path: window.location.pathname,
    referrer: "", visitor_id: getVisitorId(), session_id: getSessionId(),
  });
  try {
    fetch(`${API}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
  } catch (e) { /* ignore */ }
}
